import { useSearchParams } from "next/navigation"

export const useJobAdsSearchHasFilter = (): boolean => {
  const searchParams = useSearchParams()

  // positionCategory to delete after removing vMarion
  return (
    searchParams.has("contract") ||
    searchParams.has("position_category_uuid") ||
    searchParams.has("location") ||
    searchParams.has("q") ||
    searchParams.has("exclusive") ||
    searchParams.has("groupOffers")
  )
}
